const BASE = "v2/identity"

export const LIVENESS = `${BASE}/liveness`
export const CHECK_DOCUMENT = `${BASE}/document`
export const GET_QRCODE = `${BASE}/generate-pix`
export const CHECK_PIX = `${BASE}/check-pix`